import { Box, Typography } from "@mui/material";
import { styledComponent } from "../utils/styled";
import { useTheme } from "../context/ThemeContext";
import { ConfirmDialog } from "./ui";

// Step badge — styled after the active step row in the sidebar (Figma: node 7164-13112)
const StepBadge = styledComponent(Box)(({ isDark }) => ({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  backgroundColor: isDark ? "#434950" : "#D1D3D6",
  borderRadius: "8px",
  padding: "4px 6px",
  maxWidth: "100%",
}));

const StepNumberBox = styledComponent(Box)(({ isDark }) => ({
  width: "22px",
  height: "22px",
  minWidth: "22px",
  borderRadius: "6px",
  backgroundColor: isDark ? "#262A2E" : "#FFFFFF",
  border: isDark ? "1px solid transparent" : "1px solid #D5D9DF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
}));

const StepNumberText = styledComponent(Typography)(({ isDark }) => ({
  fontFamily: "Inter",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.035px",
  color: isDark ? "#F4F4FB" : "#31363B",
}));

const StepNameText = styledComponent(Typography)(({ isDark }) => ({
  fontFamily: "Inter",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.035px",
  color: isDark ? "#F1F4F8" : "#434950",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: "280px",
}));

/**
 * Confirmation modal before deleting a step.
 *
 * Props:
 *   open       – whether the modal is visible
 *   stepNumber – 1-based number of the step to delete
 *   stepName   – display name of the step
 *   onConfirm  – () => void
 *   onCancel   – () => void
 */
export function DeleteStepModal({
  open,
  stepNumber,
  stepName,
  onConfirm,
  onCancel,
}) {
  const { isDark } = useTheme();

  return (
    <ConfirmDialog
      open={open}
      onCancel={onCancel}
      onConfirm={onConfirm}
      title='Delete Step?'
      message='Are you sure you want to delete this step? This will remove the step from the procedure.'
      confirmLabel='Delete'
      isDark={isDark}
    >
      <StepBadge isDark={isDark}>
        <StepNumberBox isDark={isDark}>
          <StepNumberText isDark={isDark}>{stepNumber}</StepNumberText>
        </StepNumberBox>
        <StepNameText isDark={isDark}>{stepName}</StepNameText>
      </StepBadge>
    </ConfirmDialog>
  );
}
